import React from 'react';

import IconButton from '@material-ui/core/IconButton';

import PrimaryButton from '../../../../components/Buttons/PrimaryButton';
import WarningTooltip from "../../../../components/WarningTooltip";
import {DetailsIcon} from "../../../../images";


const MusterdepotButton = (props) => {
  const Icon = () => <DetailsIcon color={'currentColor'} fontSize={'1em'} />;

  return props.variant === 'icon'
    ?
      <WarningTooltip
        title={props.text}
        icon={
          <IconButton classes={props.customClasses} color={'primary'} onClick={props.onButtonClick} disabled={props.disabled}>
            <Icon/>
          </IconButton>
        }
      />
    :
      <PrimaryButton
        id={props.id}
        variant={props.variant}
        text={props.text}
        onButtonClick={props.onButtonClick}
        icon={<Icon/>}
        disabled={props.disabled}
        customClasses={props.customClasses}
      />
};

MusterdepotButton.defaultProps = {
  variant: 'text',
  text: 'Depotsimulation'
};

export default MusterdepotButton;